module.exports = __webpack_public_path__ + "static/media/uniswap.1d894675.png";